import { EChatModalActionTypes } from '../../actions/chatModal';
import { IChatModal } from '../../types/chatModal';
import { TReduxActions } from '../../types/redux';

export const chatModalInitialState: IChatModal = {
  isOpen: false,
  gaLabel: undefined,
  offerId: 0,
  defaultMessage: undefined,
};

export function chatModalReducer(state: IChatModal = chatModalInitialState, action: TReduxActions): IChatModal {
  switch (action.type) {
    case EChatModalActionTypes.Open: {
      return {
        ...state,
        isOpen: true,
        ...action.payload,
      };
    }

    case EChatModalActionTypes.Close: {
      return {
        ...state,
        isOpen: false,
        offerId: 0,
        gaLabel: undefined,
        defaultMessage: undefined,
      };
    }
  }

  return state;
}
